import { QuantityInput, Control, ControlContainer, Input } from './styles'

QuantityInput.Control = Control
QuantityInput.ControlContainer = ControlContainer
QuantityInput.Input = Input

export default QuantityInput
